<template>
    <div  class="sphome">
        <div id="toolbar" class="tool_bar" ref="tool_bar">
              <ul  class="ul_tools ">
                  <li >
                  <span id="collect_expend" class="icon-jiantou_liebiaoxiangzuo zhedie-button iconfontcolor"  @click.stop="btn('collect_expend')"> </span>
                  </li>
                  <li >
                      <span id="edit_view"   class="icon-yulan font-button iconfontcolor" style="padding:2px ;font-size: 24px;width:30px;"  @click.stop="btn('edit_view')"> </span>
                  </li>

              </ul>
            <ul class="editbutton ul_tools ">
                  <li v-for="item in opList"
                :key="item.index"
                :title="item.title"
                :id="item.name"
                @click.stop="btn(item.name) ">
                <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                <span v-else :class="item.class +' '+ item.pic+'  '"  :style="item.style"></span>
            </li>

              </ul>
            <ul class="ul_tools">
                <li v-for="item in pageList"
                    :key="item.index"
                    :title="item.title"
                    :id="item.name"
                    @click.stop="btn(item.name) ">
                    <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                    <span v-else :class="item.class +' '+ item.pic"  :style="item.style"></span>
                </li>
            </ul>
            <ul class="ul_tools">
            <li  >
                <el-divider  class="iconfont icon-button " direction="vertical"></el-divider>
            </li>
            <li  >
                <span id="zitijiacu"  class="iconfont font-button  icon-zitijiacu" @click.stop="btn('zitijiacu')"></span>
            </li>
            <li>
                <span id="zitixieti" class="iconfont font-button icon-zitixieti" @click.stop="btn('zitixieti')"></span>
            </li>

            <li >
                <el-select v-model="font.fontFamily" :placeholder="$t('form_please_select')" style="width:100px; line-height: 36px;border-radius: 0px; " @change="setFont('font-family','fontFamily')" size="mini">
                    <el-option
                            class="select_item"
                            v-for="item in fontList"
                            :key="item.value"
                            :label="item"
                            :value="item">
                    </el-option>
                </el-select>
            </li>
            <li  >
                <el-select v-model="font.fontSize" :placeholder="$t('form_please_select')" allow-create filterable style="width:80px; line-height: 36px;" @change="setFont('font-size','fontSize')" size="mini">
                    <el-option
                            class="select_item"
                            v-for="item in fontSizeList"
                            :label="item"
                            :value="item">
                    </el-option>
                </el-select>
            </li>
            <li>
                <el-color-picker v-model="setOptions.foreColor" size="mini" style="margin-top:4px;" @change="setColor('foreColor')"  ></el-color-picker>
            </li>

            <li>
                <el-color-picker v-model="setOptions.backColor" size="mini" style="margin-top:4px;" @change="setColor('backColor')" ></el-color-picker>
            </li>

            </ul>
            <ul class="ul_tools">

            <li v-for="item in toolList"
                :key="item.index"
                :title="item.title"
                @click.stop="btn(item.name) ">
                <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                <span v-else :class="item.class"></span>
            </li>

            <li>
                <el-color-picker v-model="linecolor" size="mini" style="margin-top:4px;"></el-color-picker>
            </li>


            <li >

                <el-dropdown >
                    <span id="lineselect" value="line" class="iconfont icon-button icon-line" ></span>
                    <el-dropdown-menu slot="dropdown" size="mini">
                        <el-dropdown-item
                                v-for="item in lineMenu"
                                :key="item.index"
                                :title="item.title"
                                @click.native="btn(item.name) ">
                            <span :class="item.class +' '+ item.pic"></span>
                        </el-dropdown-item>


                    </el-dropdown-menu>
                </el-dropdown>
            </li>


            <li>
                 <span id="borderselect" value="all" class="iconfont dp-left-button icon-24gl-borderAll" @click.stop="btn('border-btn') "></span>
            </li>
            <li>
                <el-dropdown>
                    <span class=" dp-right-button el-icon-caret-bottom" ></span>
                <el-dropdown-menu slot="dropdown" size="mini">
                    <el-dropdown-item
                    v-for="item in borderMenu"
                    :key="item.index"
                    :title="item.title"
                    @click.native="btn(item.name) ">
                        <span :class="item.class +' '+ item.pic"></span>
                    </el-dropdown-item>


                </el-dropdown-menu>
                </el-dropdown>
            </li>

        </ul>
            <ul class="editbutton ul_tools ">
                <li v-for="item in popList"
                    :key="item.index"
                    :title="item.title"
                    :id="item.name"
                    @click.stop="btn(item.name) ">
                    <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                    <span v-else :class="item.class +' '+ item.pic+'  '"  :style="item.style"></span>
                </li>

            </ul>
        </div>

<div  class="content">
    <el-popover ref="pop_json"
                placement="bottom-end"
                popper-class="json_content"
                trigger="click">
        <jeditor ref="jeditor"    :jMode="'tree'"  :jData="sets" style="height:100%;width:100%;" ></jeditor>
    </el-popover>

    <el-popover ref="pop_set"
                placement="bottom-end"
                popper-class="set_pop_content"
                trigger="click">
        <spreadSet ref="spreadset"  :cell="cellInfo"   :acsheet="activeSheet"  style="height:100%;width:100%;" ></spreadSet>
    </el-popover>


            <div ref="spread" id="spreadContent"  class="sp_content" >


            </div>



            <div id="setfontstyle" style="display: none"></div>
            <input type="file" style="display:none"  name="upload_pic" ref="upload_pic" id="upload_pic" @change="loadPicture"/>


        </div>

    </div>
</template>
<script>
    import jeditor from "./jsonEditor";
    import spreadSet from "./spreadSet";
    export default {
        name: "spreadBase",
        components: {
            spreadSet,
            jeditor,
         },
        props: {
            spdata:Object,
            spview:Object,
        },

        watch: {

            cellrange(a,b){

                this.initStyle();

            },
            spdata: {

                handler(n, o) {
                    this.spreadData=n;
                    this.openSpread();
                },
            },


            spview(a,b){

                    this.viewSpread(a);
            },

        },
        data() {
            return {
                spreadData:{},
                editType:true,
                spread:{},
                excelIo:{},
                activeSheet:{},
                cellrange:{},
                cellInfo:{},
                rangeObj:{},
                sets:{},
                picObj:{name:'',selected:false},
                linecolor:'#000',
                setOptions:{foreColor:'#000000',backColor:'#FFFFFF'},
                spreadNS : GC.Spread.Sheets,
                borderMenu:{all:{name:'border-all',pic:'icon-24gl-borderAll',title:'ALL',class:'icon-menu iconfont '},outline:{name:'border-outline',pic:'icon-24gl-borderOutside',title:'OutSide',class:'icon-menu iconfont '},top:{name:'border-top',title:'Top',pic:'icon-24gl-borderTop',class:'icon-menu iconfont '},right:{name:'border-right',title:'Right',pic:'icon-24gl-borderRight',class:'icon-menu iconfont '},bottom:{name:'border-bottom',title:'Bottom',pic:'icon-24gl-borderBottom',class:'icon-menu iconfont '},left:{name:'border-left',title:'Left',pic:'icon-24gl-borderLeft',class:'icon-menu iconfont '},inside:{name:'border-inside',title:'Inside',pic:'icon-24gl-borderInside',class:'icon-menu iconfont '},innerVertical:{name:'border-innerVertical',title:'InsideCol',pid:'icon-24gl-borderInsideCol',class:'icon-menu iconfont '},innerHorizontal:{name:'border-innerHorizontal',title:'InsideRow',pic:'icon-24gl-borderInsideRow',class:'icon-menu iconfont '},none:{name:'border-none',title:'None',pic:'iconfont icon-24gl-borderNone',class:'icon-menu '}},
                fileList:{divider:{class:'divider'},new:{name:'file-new',title:this.$t('report_new'),data:1,style:'padding:4px ;font-size:26px',pic:'icon-wenjian1',class:'font-button iconfontcolor'},newCopy:{name:'file-newCopy',title:this.$t('report_copy_new'),data:1,style:'padding:4px;font-size:26px',pic:'icon-light-component-filedeal-copyfile',class:'font-button iconfontcolor'},template:{name:'file-template',title:this.$t('report_import_template'),data:1,style:'padding:1px 1px;font-size:32px',pic:'icon-daoru',class:'font-button iconfontcolor'},templateout:{name:'file-templateout',title:this.$t('report_export_template'),data:1,style:'padding:1px 1px;font-size:32px',pic:'icon-daochu',class:'font-button iconfontcolor'},save:{name:'file-save',title:this.$t('button_save'),data:1,style:'padding:2px 1px;font-size:28px',pic:'icon-autosave',class:'font-button iconfontcolor'}},
                obList:{divider_op:{class:'divider'},xianpi:{name:'clear-clear',title:this.$t('report_rubber'),data:1,style:'font-size:22px',pic:'icon-xiangpi1',class:'font-button iconfontcolor'},table:{name:'table-table',title:this.$t('report_insert_table'),data:1,pic:'icon-charubiaoge',class:'font-button iconfontcolor'},image:{name:'image-image',title:this.$t('report_insert_image'),style:'font-size:22px',data:1,pic:'icon-tubiaozhizuomoban',class:'font-button iconfontcolor'},chat:{name:'op-xz',title:this.$t('report_insert_chart'),data:1,style:'font-size:24px',pic:'icon-mianxingbingtu',class:'font-button iconfontcolor'}},
                pageList:{divider_p:{class:'divider'},saveas:{name:'page-saveas',title:this.$t('report_save_as'),data:1,style:'padding:2px;font-size:28px',pic:'icon-excel',class:'font-button iconfontcolor'},print:{name:'page-print',title:this.$t('report_print_preview'),data:1,style:'font-size:24px',pic:'icon-dayinyulan',class:'font-button iconfontcolor'},zoom_in:{name:'page-zoom_out',title:this.$t('report_magnify'),data:1,style:'padding:0 0 0 2px;font-size:28px',pic:'icon-suofangda',class:'font-button iconfontcolor'},zoom_out:{name:'page-zoom_in',title:this.$t('report_reduce'),data:1,style:'padding:0 0 0 2px;font-size:28px',pic:'icon-suofangxiao',class:'font-button iconfontcolor'}},
                alignList:[{class:'divider'},{name:'align-0',title:this.$t('report_left_aligned'),class:'icon-button iconfont icon-zuoduiqi'},{name:'align-1',title:this.$t('report_center'),class:'icon-button iconfont icon-juzhongduiqi'},{name:'align-2',title:this.$t('report_be_at_the_right'),class:'icon-button iconfont icon-youduiqi'}],
                valignList:[{name:'valign-0',title:this.$t('report_be_ahead_of'),class:' iconfont icon-wenbendingbuduiqi icon-button'},{name:'valign-1',title:this.$t('report_center'),class:'icon-button iconfont icon-wenbenzuoyouduiqi'},{name:'valign-2',title:this.$t('report_be_content_to_follow'),class:'icon-button iconfont icon-wenbendibuduiqi'}],
                mergeList:[{class:'divider'},{name:'freeze-freeze',title:this.$t('report_lock'),class:'icon-button iconfont icon-freeze'},{name:'merge-merge',title:this.$t('report_merge'),class:'icon-button iconfont icon-hebingdanyuange'},{name:'unmerge-unmerge',title:this.$t('report_cancel_merge'),class:'icon-button iconfont icon-quxiaohebingdanyuange'},{class:'divider'}],
                popList:{divider_op:{class:'divider'},datasource:{name:'ds-data',title:this.$t('report_configuration'),data:1,style:'padding:5px;',pic:'icon-wulitu_shujuku',class:'font-button iconfontcolor'},sx:{name:'sx-sx',title:this.$t('report_attribute'),data:1,style:'padding: 3px;font-size:22px',pic:'icon-zhuticipeizhi',class:'font-button iconfontcolor'}},

                toolList:[],
                fontSizeList:['8pt','10pt','12pt','14pt','20pt','24pt','32pt','40pt'],
                fontList:['Arial','Calibri','Cambria','宋体','微软雅黑'],
                font:{fontFamily:"Calibri",fontSize:"16pt",fontStyle:"normal",fontVariant:"normal",fontWeight:"bold",lineHeight:"normal"},
                lineMenu:{line:{name:'line-line',title:'',data:1,pic:'icon-line',class:'icon-menu iconfont '},solid:{name:'line-solid',title:'',data:2,pic:'icon-solid-border',class:'icon-menu iconfont '},dianxian:{name:'line-dianxian',title:'',data:3,pic:'icon-dianxian',class:'icon-menu iconfont '},dash:{name:'line-dash',title:'',data:4,pic:'icon-dash',class:'icon-menu iconfont '}},
                opList:{},
                }
        },
        mounted() {
            this.initSpread();
            this.toolList=this.alignList.concat(this.valignList).concat(this.mergeList);
            this.opList=Object.assign(this.fileList,this.obList);
            $("#toolbar").find(".el-color-picker__trigger").css("border","0px");
            $("#toolbar").find(".el-color-picker__icon").removeClass("el-icon-arrow-down");

            this.onResize();



        },
        beforeDestroy(){

        },
        methods: {
            initSpread(){

                this.sets={};
                this.spreadData.template={};
                this.spreadData.set={};
                this.spread=new this.spreadNS.Workbook($('#spreadContent')[0]);
                this.excelIo =new GC.Spread.Excel.IO();
                this.spread.bind(GC.Spread.Sheets.Events.ActiveSheetChanged, this.activeSheetChanged);
                this.spread.bind(GC.Spread.Sheets.Events.SelectionChanged, this.rangeChanged);


            },
            onResize (){
                    $(".sp_content").height($(".sphome").height()*1 -  $("#toolbar").height()*1);
                    this.spread.refresh();
            },

            btn(id){
                if(id==undefined) return;
                let id_family=id.split("-");
                let sid=id_family[1];
                switch (id_family[0]) {
                    case 'zitijiacu':

                        this.font.fontWeight=$("#zitijiacu").is(".font-checked")?'normal':'bold';
                    $("#zitijiacu").toggleClass("font-checked");
                        this.setFont('font-weight','fontWeight');
                        break;
                    case 'zitixieti':

                        this.font.fontStyle=$("#zitixieti").is(".font-checked")?'normal':'italic';
                        $("#zitixieti").toggleClass("font-checked")
                        this.setFont('font-style','fontStyle');
                        break;
                    case 'border':
                        this.setBorder(sid);
                        break;
                    case 'line':
                        let oldid= $("#lineselect").attr("value");
                        $("#lineselect").removeClass(this.lineMenu[oldid].pic);
                        $("#lineselect").addClass(this.lineMenu[sid].pic);
                        $("#lineselect").attr("value",sid);
                        break;
                    case 'align':
                        this.setStyle('hAlign',sid*1);
                        break;
                    case 'file':
                        this.setFile(sid);
                        break;

                    case 'page':
                        this.setPage(sid);
                        break;
                    case 'valign':
                        this.setStyle('vAlign',sid*1);
                        break;
                    case 'merge':
                        this.mergeCells();
                        break;
                    case 'unmerge':
                        this.unmergeCells();
                        break;
                    case 'clear':
                        let sheet= this.cellrange.sheet;
                        if(this.picObj.selected)
                            { sheet.pictures.remove(this.picObj.name);
                            this.picObj.selected=false;}
                        else {
                            this.unmergeCells();
                            sheet.suspendPaint();
                            this.cellrange.clear(GC.Spread.Sheets.StorageType.data);
                            this.cellrange.clear(GC.Spread.Sheets.StorageType.style);
                            this.cellrange.clear(GC.Spread.Sheets.StorageType.tag);
                            this.cellrange.clear(GC.Spread.Sheets.StorageType.comment);
                            this.cellrange.clear(GC.Spread.Sheets.StorageType.sparkline);
                            sheet.resumePaint();
                        }
                        break;
                    case 'table':
                        console.log(this.cellInfo);
                        let i=0;
                        this.cellrange.sheet.tables.all().forEach(function(table){
                            let t=parseInt(table.name().replace('Table',''));
                            if (t>i) i=t;

                        });
                        var tableStyle = GC.Spread.Sheets.Tables.TableThemes.light1;
                        var table = this.cellrange.sheet.tables.add('Table'+(i+1), this.cellrange.row,this.cellrange.col,this.cellrange.rowCount,this.cellrange.colCount, tableStyle);
                         break;
                    case 'image':
                        this.$refs.upload_pic.dispatchEvent(new MouseEvent('click'));
                        break;
                    case 'freeze':
                        this.cellrange.sheet.options.frozenlineColor=this.linecolor;
                        this.cellrange.sheet.frozenRowCount(this.cellrange.sheet.getActiveRowIndex());
                        this.cellrange.sheet.frozenColumnCount(this.cellrange.sheet.getActiveColumnIndex());
                        break;
                    case 'collect_expend':
                        if($("#collect_expend").hasClass("icon-jiantou_liebiaoxiangzuo")) {

                            $("#collect_expend").removeClass("icon-jiantou_liebiaoxiangzuo");
                            $("#collect_expend").addClass("icon-jiantou_liebiaoxiangyou");
                            this.$parent.btn('collect');
                        }
                        else
                        {
                            $("#collect_expend").removeClass("icon-jiantou_liebiaoxiangyou");
                            $("#collect_expend").addClass("icon-jiantou_liebiaoxiangzuo");
                            this.$parent.btn('expend');
                        }
                        break;
                    case 'edit_view':
                        if(!$(".editbutton").hasClass("font-disable")) {
                            this.spreadData.template=this.spread.toJSON();
                            this.spreadData.set=this.$refs.jeditor.getJsonData();
                            this.$parent.btn('run');
                        }
                        else
                        {
                            $(".editbutton").removeClass("font-disable")
                            $("#edit_view").removeClass("icon-yulan1");
                            $("#edit_view").addClass("icon-yulan");
                            this.openSpread();
                        }
                        break;
                    case 'ds':

                        if($(".icon-wulitu_shujuku").hasClass("font-checked"))
                        {
                            $(".icon-wulitu_shujuku").removeClass("font-checked");
                            this.$refs.pop_json.showPopper =false;

                        }
                        else {
                            $(".icon-wulitu_shujuku").addClass("font-checked");
                            this.$refs.pop_json.showPopper =true;

                        }
                        break;
                    case 'sx':

                        if($(".icon-zhuticipeizhi").hasClass("font-checked"))
                        {
                            $(".icon-zhuticipeizhi").removeClass("font-checked");
                            this.$refs.pop_set.showPopper =false;

                        }
                        else {
                            $(".icon-zhuticipeizhi").addClass("font-checked");
                            this.$refs.pop_set.showPopper =true;

                        }
                        break;
                    default: break;
                }
            },
            openSpread() {
                    this.sets={parm:{},ds:{},info:{name:this.$t('report_untitled')}};
                    this.spread.fromJSON(this.spreadData.template);
                    this.sets=this.spreadData.set;
                    $("#edit_view").removeClass("icon-yulan1");
                    $("#edit_view").addClass("icon-yulan");
                    $(".editbutton").removeClass("font-disable");
                    this.activeSheet=this.spread.getActiveSheet();


            },
            viewSpread(a){
                $("#edit_view").removeClass("icon-yulan");
                $("#edit_view").addClass("icon-yulan1");
                $(".editbutton").addClass("font-disable");
                this.$refs.pop_json.showPopper =false;

                $(".icon-set-color").removeClass("font-checked");
                this.$refs.pop_set.showPopper =false;
                this.spread.fromJSON(a);

            },
            initStyle(){
                let self=this;
                 let s=this.cellrange.sheet.getActualStyle(this.cellrange.row,this.cellrange.col, this.cellrange.sheetArea);
                 if (!s){ s=new GC.Spread.Sheets.Style;}
                 this.setOptions.foreColor=s.foreColor?s.foreColor:'#000';
                 this.setOptions.backColor=s.backColor?s.backColor:'#FFF';
                  $(".icon-zitijiacu").removeClass("font-checked");
                  $(".icon-zitixieti").removeClass("font-checked");
                  if (s.font){
                      let fobj=this.parseFont(s.font);
                      this.font={...fobj};
                      if(this.font.fontWeight=='bold') $(".icon-zitijiacu").addClass("font-checked");
                      if(this.font.fontStyle=='italic') $(".icon-zitixieti").addClass("font-checked");
                  }
                    this.cellrange.sheet.bind(GC.Spread.Sheets.Events.PictureSelectionChanged, function(e, args) {
                    self.picObj.name=args.picture.name();
                    self.picObj.selected=args.picture.isSelected();

                });

            },
            rangeChanged(e,args){
                var row = args.newSelections[0].row;
                var col = args.newSelections[0].col;
                var rowCount = args.newSelections[0].rowCount;
                var colCount =args.newSelections[0].colCount;
                this.cellrange= new GC.Spread.Sheets.CellRange(args.sheet, row, col, rowCount, colCount, GC.Spread.Sheets.SheetArea.viewport);
                this.cellInfo=this.getCellInfo(args.sheet,row,col);
            },
            activeSheetChanged(e,args){
                this.activeSheet=args.newSheet;
                this.cellInfo={};
                this.cellrange={};

            },
            setFile(op){
                switch (op) {
                    case 'new':
                        this.spread.destroy();
                        this.initSpread();

                        this.$parent.newTemplate(0);
                        break;
                    case 'template':
                        this.$parent.openTemplate();
                        break;
                    case 'templateout':
                        this.spreadData.template=this.spread.toJSON();
                        this.spreadData.set=this.$refs.jeditor.getJsonData();
                        this.$parent.saveTemplateToJson(this.spreadData);
                        break;
                    case 'newCopy':
                        this.$parent.newTemplate(1);
                        break;
                    case 'save':
                        this.spreadData.template=this.spread.toJSON();
                        this.spreadData.set=this.$refs.jeditor.getJsonData();
                        this.$parent.saveTemplateToSvr(this.spreadData);
                        break;

                    default:
                        break;
                }
            },
            setPage(op){
                switch (op) {
                    case 'print':
                        let sheet = this.spread.getActiveSheet();
                        let printInfo = sheet.printInfo();
                        printInfo.showBorder(false);
                        printInfo.showGridLine(false);
                        this.spread.print(0);
                        break;
                    case 'zoom_in':
                        var zoom = this.spread.getActiveSheet().zoom();
                        this.spread.getActiveSheet().zoom(zoom - 0.1);
                        break;
                    case 'zoom_out':
                        var zoom = this.spread.getActiveSheet().zoom();
                        this.spread.getActiveSheet().zoom(zoom + 0.1);
                        break;
                    case 'saveas':
                        this.saveTemplateToExcel();
                        break;
                    default:
                        break;
                }
            },
            //保存EXCEL
            saveTemplateToExcel(){
                //生成时间戳

                let fileName = new Date().getTime() + '.xlsx';
                let json =this.spread.toJSON({includeBindingSource: true});
                this.excelIo.save(json, (blob) => {
                    saveAs(blob, fileName);
                }, function (e) {
                    console.log(e);
                });
            },

            setStyle(prop,val){
                let sheet= this.cellrange.sheet;
                sheet.suspendPaint();
                let row=this.cellrange.row;
                let col=this.cellrange.col;
                let rowCount=this.cellrange.rowCount;
                let colCount=this.cellrange.colCount;
                for (let i=0;i<rowCount;i++){
                    for (let j=0;j<colCount;j++){
                        let style = sheet.getStyle(i+row,j+col);
                        if (!style) {
                            style =new GC.Spread.Sheets.Style;
                        }

                        style[prop]=val;
                        sheet.setStyle(i+row, j+col, style);
                    }
                }
                sheet.resumePaint();
            },
            setBorder(id){

               let oldid=$("#borderselect").attr("value");
               if (id=='btn')
                   id=$("#borderselect").attr("value");
               else
               {
                   $("#borderselect").removeClass(this.borderMenu[oldid].pic);
                   $("#borderselect").addClass(this.borderMenu[id].pic);
                   $("#borderselect").attr("value",id);
               }

                let bordType={};
                bordType[id]=true;

                let linename= $("#lineselect").attr("value");
                if (id=='none')
                    this.cellrange.setBorder(null, {all:true});
                else
                    this.cellrange.setBorder(new GC.Spread.Sheets.LineBorder(this.linecolor,this.lineMenu[linename].data), bordType);
            },
            setFont(name,id){
                let sheet= this.cellrange.sheet;
                sheet.suspendPaint();
                let row=this.cellrange.row;
                let col=this.cellrange.col;
                let rowCount=this.cellrange.rowCount;
                let colCount=this.cellrange.colCount;
                for (let i=0;i<rowCount;i++){
                    for (let j=0;j<colCount;j++){
                        var style = sheet.getStyle(i+row,j+col);
                        if (!style) {
                            style =new GC.Spread.Sheets.Style;
                        }
                        // reset themeFont to make sure font be used
                        style.themeFont = undefined;
                        style= this.updateStyleFont(sheet,style,name,this.font[id]);
                        sheet.setStyle(i+row, j+col, style);
                    }
                }
                sheet.resumePaint();
            },
           updateStyleFont(sheet,style,prop,val) {
                      let styleEle = $("#setfontstyle");
                      let defaultStyle = sheet.getDefaultStyle();
                    if (!style.font) {
                        style.font = defaultStyle.font || "11pt Calibri";
                    }
                    $(styleEle).css("font",style.font);
                    $(styleEle).css(prop, val);
                    style.font = styleEle[0].style.font;
                    return style;

            },


            setColor(t){
                this.setStyle(t,this.setOptions[t]);

            },
            loadPicture() {
                let self=this;
                var file = document.getElementById("upload_pic").files[0];
                var fileName = file.name;
                var index = fileName.lastIndexOf('.');
                var fileExt = fileName.substr(index + 1).toLowerCase();
                if (fileExt === 'jpg' || fileExt === 'png' ) {
                    var reader = new FileReader();
                    reader.onload = function () {
                        self.addPicture(this.result);
                    }
                        reader.readAsDataURL(file);

                } else {
                    alert(getResource("messages.invalidImportFile"));
                }




               $("#upload_pic").val("");

            },
            addPicture(url){
                let sheet=this.cellrange.sheet;
                sheet.suspendPaint();
                let defaults = sheet.defaults, rowHeight = defaults.rowHeight, colWidth = defaults.colWidth;
                let picture = sheet.pictures.add('picture1', url, this.cellrange.col * colWidth, this.cellrange.row * rowHeight,this.cellrange.colCount *colWidth, this.cellrange.rowCount * rowHeight)
                    .backColor("#FFFFFF").borderColor("#000000")
                    .borderStyle("solid").borderWidth(1).borderRadius(3);
                sheet.resumePaint();
            },
            mergeCells() {
                var sheet=this.cellrange.sheet;
                var sels = sheet.getSelections();
                var rowCount = sheet.getRowCount(),
                    columnCount = sheet.getColumnCount();

                for (var n = 0; n < sels.length; n++) {
                    var sel = this.getActualCellRange(sheet, sels[n], rowCount, columnCount);
                    sheet.addSpan(sel.row, sel.col, sel.rowCount, sel.colCount);
                }
            },
            unmergeCells() {
                var sheet=this.cellrange.sheet;
                function removeSpan(range) {
                    sheet.removeSpan(range.row, range.col);
                }

                var sels = sheet.getSelections();
                var rowCount = sheet.getRowCount(),
                    columnCount = sheet.getColumnCount();

                for (var n = 0; n < sels.length; n++) {
                    var sel = this.getActualCellRange(sheet, sels[n], rowCount, columnCount);
                    sheet.getSpans(sel).forEach(removeSpan);
                }
            },
            getCellInfo(sheet, row, column) {
                var result = {type: ""}, object;

                if ((object = sheet.comments.get(row, column))) {
                    result.type = "comment";
                } else if ((object = sheet.tables.find(row, column))) {
                    result.type = "table";
                }
                result.sheet=sheet;
                result.row=row;
                result.col=column;
                result.object = object;

                return result;
            },

            getActualCellRange(sheet, cellRange, rowCount, columnCount) {
                if (cellRange.row === -1 && cellRange.col === -1) {
                    return new this.spreadNS.CellRange(sheet, 0, 0, rowCount, columnCount);
                }
                else if (cellRange.row === -1) {
                    return new this.spreadNS.CellRange(sheet, 0, cellRange.col, rowCount, cellRange.colCount);
                }
                else if (cellRange.col === -1) {
                    return new this.spreadNS.CellRange(sheet, cellRange.row, 0, cellRange.rowCount, columnCount);
                }
                return new this.spreadNS.CellRange(sheet, cellRange.row, cellRange.col, cellRange.rowCount, cellRange.colCount);
            },
            parseFont(font) {
                var fontFamily = null,
                    fontSize = null,
                    fontStyle = "normal",
                    fontWeight = "normal",
                    fontVariant = "normal",
                    lineHeight = "normal";

                var elements = font.split(/\s+/);
                var element;
                while ((element = elements.shift())) {
                    switch (element) {
                        case "normal":
                            break;

                        case "italic":
                        case "oblique":
                            fontStyle = element;
                            break;

                        case "small-caps":
                            fontVariant = element;
                            break;

                        case "bold":
                        case "bolder":
                        case "lighter":
                        case "100":
                        case "200":
                        case "300":
                        case "400":
                        case "500":
                        case "600":
                        case "700":
                        case "800":
                        case "900":
                            fontWeight = element;
                            break;

                        default:
                            if (!fontSize) {
                                var parts = element.split("/");
                                fontSize = parts[0];
                                if (fontSize.indexOf("px") !== -1) {
                                    fontSize = this.px2pt(parseFloat(fontSize)) + 'pt';
                                }
                                if (parts.length > 1) {
                                    lineHeight = parts[1];
                                    if (lineHeight.indexOf("px") !== -1) {
                                        lineHeight = this.px2pt(parseFloat(lineHeight)) + 'pt';
                                    }
                                }
                                break;
                            }

                            fontFamily = element;
                            if (elements.length)
                                fontFamily += " " + elements.join(" ");

                            return {
                                "fontStyle": fontStyle,
                                "fontVariant": fontVariant,
                                "fontWeight": fontWeight,
                                "fontSize": fontSize,
                                "lineHeight": lineHeight,
                                "fontFamily": fontFamily
                            };
                    }
                }

        return {
            "fontStyle": fontStyle,
            "fontVariant": fontVariant,
            "fontWeight": fontWeight,
            "fontSize": fontSize,
            "lineHeight": lineHeight,
            "fontFamily": fontFamily
        };
      },
            px2pt(pxValue) {
                var tempSpan = $("<span></span>");
                tempSpan.css({
                    "font-size": "96pt",
                    "display": "none"
                });
                tempSpan.appendTo($(document.body));
                var tempPx = tempSpan.css("font-size");
                if (tempPx.indexOf("px") !== -1) {
                    var tempPxValue = parseFloat(tempPx);
                    return Math.round(pxValue * 96 / tempPxValue);
                }
                else {  // when browser have not convert pt to px, use 96 DPI.
                    return Math.round(pxValue * 72 / 96);
                }
            },
        setFormatter(value) {
            var _this=this;
            var sheet = this.spread.getActiveSheet();
            this.execInSelections(sheet, "formatter", function (sheet, row, column) {
                var style = sheet.getStyle(row, column);
                if (!style) {
                    style = new _this.spreadNS.Style();
                }
                style.formatter = value;
                sheet.setStyle(row, column, style);
            });
        },

       execInSelections(sheet, styleProperty, func) {
            sheet.suspendPaint();
            var selections = sheet.getSelections();
            for (var k = 0; k < selections.length; k++) {
                var selection = selections[k];
                var col = selection.col, row = selection.row,
                    rowCount = selection.rowCount, colCount = selection.colCount;
                if ((col === -1 || row === -1) && styleProperty) {
                    var style, r, c;
                    // whole sheet was selected, need set row / column' style one by one
                    if (col === -1 && row === -1) {
                        for (r = 0; r < rowCount; r++) {
                            if ((style = sheet.getStyle(r, -1)) && style[styleProperty] !== undefined) {
                                func(sheet, r, -1);
                            }
                        }
                        for (c = 0; c < colCount; c++) {
                            if ((style = sheet.getStyle(-1, c)) && style[styleProperty] !== undefined) {
                                func(sheet, -1, c);
                            }
                        }
                    }
                    // Get actual range for whole rows / columns / sheet selection
                    if (col === -1) {
                        col = 0;
                    }
                    if (row === -1) {
                        row = 0;
                    }
                    // set to each cell with style that in the adjusted selection range
                    for (var i = 0; i < rowCount; i++) {
                        r = row + i;
                        for (var j = 0; j < colCount; j++) {
                            c = col + j;
                            if ((style = sheet.getStyle(r, c)) && style[styleProperty] !== undefined) {
                                func(sheet, r, c);
                            }
                        }
                    }
                }
                if (selection.col == -1 && selection.row == -1) {
                    func(sheet, -1, -1);
                }
                else if (selection.row == -1) {
                    for (var i = 0; i < selection.colCount; i++) {
                        func(sheet, -1, selection.col + i);
                    }
                }
                else if (selection.col == -1) {
                    for (var i = 0; i < selection.rowCount; i++) {
                        func(sheet, selection.row + i, -1);
                    }
                }
                else {
                    for (var i = 0; i < selection.rowCount; i++) {
                        for (var j = 0; j < selection.colCount; j++) {
                            func(sheet, selection.row + i, selection.col + j);
                        }
                    }
                }
            }
            sheet.resumePaint();
        }


    }
    }
</script>

<style  lang="scss" >
    .ul_tools {
        display: flex;
        float: left;
    }

    .sphome {
        margin-top: 0px;
        height:100% ;
        width: 100%;
    }

    .tool_bar {
        position: relative;
        float: left;
        //height: 40px;
        width:100%;
        border-bottom: 1px solid #d5d7da;
        z-index: 1000;
    }

    .content {
        position: relative;
        margin: 0;
        padding: 0;
        width: 100%;
        height: calc(100% - 40px);
        overflow: hidden;
    }
    .json_content {
        position: absolute;
        margin: 0;
        padding: 0;
        left:calc(100% - 625px);
        width: 600px;
        color: #774917;
        background: #3a5c71;
        height: calc(100% - 30px);
        /*opacity: 0.97;*/
        overflow: hidden;
    }
    .set_pop_content {
        position: absolute;
        margin: 0;
        padding: 0;
        left:calc(100% - 325px);
        width: 300px;
        color: #774917;
        background: #a3abb8;
        /*height: 400px;*/
        opacity: 0.8;
        overflow: hidden;
    }
    .sp_content {
        position: relative;
        margin: 0;
        padding: 0;
        //border: 3px solid #872519;
        width: 100%;
        height: calc(100% - 0px);
        overflow: hidden;
    }
    .icon-button {
        margin-top:5px;
        padding: 2px 0px;
        color: #4b7476;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:36px;

    }
    .icon-menu {
        color: #257e6c;
        outline: none;
        font-size: 24px;
    }
    .icon-button:hover {
        background: #d3d3d3;

    }
    .font-button {
        margin-top:5px;
        padding: 5px 5px;
        color: #016277;
        font-size: 14pt;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:36px;

    }
    .font-checked {
        background: #f6e3ac;

    }
    .font-button:hover {
        background: #babdbf;
        pointer-events:auto;
    }
    .font-disable {
        opacity: 0.5;
        pointer-events:none;
    }
    .zhedie-button {
        width:6px;
        margin:0px;
        padding: 11px 0px ;
        color: #4a8587;
        background: #f2f2f2;
        font-size: 16px;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:38px;
    }
    .zhedie-button:hover {
        background: #f6e3ac;
        pointer-events:auto;
    }
    .dp-left-button {
        padding-right: 0;
        margin-right: 0px;
        text-align: center;
        line-height:36px;
        position: relative;
        color: #016277;
        outline: none;
        cursor: pointer;
        height: 36px;
        width:20px;
    }

    .dp-left-button:hover {
        background: #d3d3d3
    }
    .dp-right-button {
        text-align: center;
        line-height:36px;
        font-size: 15px;
        position: relative;
        color: #016277;
        outline: none;
        cursor: pointer;
        height: 36px;
        width:15px;
    }
    .dp-right-button:hover {
        background: #d3d3d3
    }
    .select_item{
        font-size: 9px;
    }




</style>